// extracted by mini-css-extract-plugin
export default {"contentEnquiry":"contentEnquiry--1DVJV","skeleton":"skeleton--_z5-L","skeleton-loading":"skeleton-loading--O04kA"};